import {
    get,
    store,
    update,
    destroy,
    create,
    edit,
    show,
    download
} from "@/services/resources";

    export const state = {
        editData : undefined,
        data : undefined,
        page:undefined,
        search:undefined,
        loadingPage:false,
        per_page:10,
    };
    export const mutations =  {
        SET_LOADING_PAGE(state,payload){
            state.loadingPage = payload
        },
        SET_DATA(state,payload){
            state.data = payload
        },
        SET_EDIT_DATA(state,payload){
            state.editData = payload
        },
    };
    export const actions =  {
        resetData({commit}){
            commit('SET_DATA',undefined)
            commit('SET_EDIT_DATA',undefined)
        },

        get({commit},url){
            commit('SET_DATA',undefined)
            return new Promise((resolve,reject)=>{
                get(url).then((response)=>{
                    commit('SET_DATA',response.data)
                    commit('SET_LOADING_PAGE',false)
                    resolve(response)
                }).catch((error)=>{
                    reject(error)
                })
            })
        },
        getWithoutCommit(_,url){
            return new Promise((resolve,reject)=>{
                get(url).then((response)=>{
                    resolve(response)
                }).catch((error)=>{
                    reject(error)
                })
            })
        },
        getData(_,url){
            return new Promise((resolve,reject)=>{
                get(url).then((response)=>{
                    resolve(response)
                }).catch((error)=>{
                    reject(error)
                })
            })
        },
        create({commit}, url){
            commit('SET_EDIT_DATA',undefined)
            let requestUrl = url.query ? url.url : url
            let query = url.query || ''

            return new Promise((resolve,reject)=>{
                create(requestUrl, query).then((response)=>{
                    commit('SET_EDIT_DATA',response.data)
                    resolve(response)
                }).catch((error)=>{
                    reject(error)
                })
            })
        },
        show({commit},data){
            return new Promise((resolve,reject)=>{
                show(data.resource, data.id).then((response)=>{
                   if (!data.noSetData){
                       commit('SET_DATA',response.data)
                   }
                    resolve(response)
                }).catch((error)=>{
                    reject(error)
                })
            })
        },
        edit({commit},data){
            commit('SET_EDIT_DATA',undefined)
            return new Promise((resolve,reject)=>{
                edit(data.url,data.id).then((response)=>{
                    commit('SET_EDIT_DATA',response.data)
                    resolve(response)
                }).catch((error)=>{
                    reject(error)
                })
            })
        },
        // eslint-disable-next-line no-unused-vars
        store({commit},data){
            return new Promise((resolve,reject)=>{
                store(data.resource,data.data).then((response)=>{
                    resolve(response)
                }).catch((error)=>{
                    reject(error)
                })
            })
        },
        // eslint-disable-next-line no-unused-vars
        update({commit},data){
            return new Promise((resolve,reject)=>{
                update(data.resource,data.data,data.id).then((response)=>{
                    resolve(response)
                }).catch((error)=>{
                    reject(error)
                })
            })
        },
        // eslint-disable-next-line no-unused-vars
        destroy({commit},data){
            return new Promise((resolve,reject)=>{
                destroy(data.resource,data.id).then((response)=>{
                    resolve(response)
                }).catch((error)=>{
                    reject(error)
                })
            })
        },
        download(_,data){
            return new Promise((resolve,reject)=>{
                download(data).then((response)=>{
                    resolve(response)
                }).catch((error)=>{
                    reject(error)
                })
            })
        },
    };
    export const getters =  {
        cData: state => state.data,

    };

